import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { Dashboard } from "@src/types/dashboards";

export interface GetDashboardByIdV2Result {
  success: boolean;
  data?: Dashboard;
  error?: string;
}

export const getDashboardByIdV2UseCase = async (
  dashboardId: string,
): Promise<GetDashboardByIdV2Result> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getDashboardByIdV2(
      namespace,
      dashboardId,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch dashboard").message,
    };
  }
};
